import { HardwareSku, HardwareSkuType } from "src/api/types.generated";

const PRINTER_ENDPOINT_STORAGE_KEY = "hardware-printer-endpoint";

export type PrintHardwarePackagePayload = Record<string, unknown>;

export const getHardwarePrinterEndpoint = (): string | null =>
  localStorage.getItem(PRINTER_ENDPOINT_STORAGE_KEY);

export const printHardwarePackage = async (
  payload: PrintHardwarePackagePayload
): Promise<void> => {
  const printerEndpoint = getHardwarePrinterEndpoint();
  if (!printerEndpoint) {
    throw new Error("Please set the printer endpoint URL in settings");
  }

  const response = await fetch(`${printerEndpoint}/print-hardware-package`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = response.statusText || "Unknown error";
    try {
      const errorData = await response.json();
      message = errorData?.error || message;
    } catch {
      // Response body wasn't JSON (or was empty) - fall back to statusText.
    }
    throw new Error(`Failed to print label: ${message}`);
  }
};

export const buildHardwarePrintPackage = (
  request: {
    id: number;
    user: { name: string; email: string };
    hardware_item_requests?: Array<{
      quantity: number;
      HardwareItem: { sku_code: string };
    }> | null;
  },
  skus: Pick<HardwareSku, "code" | "name" | "location" | "type">[]
): PrintHardwarePackagePayload => {
  const items =
    request.hardware_item_requests?.map((item) => {
      const sku = skus.find((s) => s.code === item.HardwareItem.sku_code);
      return {
        name: sku?.name || "Unknown Item",
        location: sku?.location || "No Location",
        quantity: item.quantity,
        isLottery: sku?.type === HardwareSkuType.Lottery,
      };
    }) || [];

  return {
    requestId: request.id,
    userEmail: request.user.email,
    userName: request.user.name,
    hasLotteryItems: items.some((item) => item.isLottery),
    items,
  };
};
